import { Button, Header, Image } from 'semantic-ui-react';
import {
	Redirect,
	Route,
	Switch,
	useHistory,
	useLocation,
	useRouteMatch,
} from 'react-router-dom';
import { Logo } from '../Logo/Logo';
import { SimpleFormWrapper } from '../SimpleFormWrapper/SimpleFormWrapper';
import { UserDetailsForm } from '../UserDetailsForm/UserDetailsForm';
import { ChoosePasswordForm } from '../ChoosePasswordForm/ChoosePasswordForm';
import './InvitationPage.less';

// tslint:disable-next-line:max-line-length
const companyLogo =
	'https://slack-files2.s3-us-west-2.amazonaws.com/avatars/2017-05-18/184906559153_9f3564a63afd92b9a26f_88.png';

const nextButton = (disableSubmit: boolean) => (
	<div className='step-button-wrapper'>
		<Button fluid type='submit' primary disabled={disableSubmit}>
			Next
		</Button>
	</div>
);

export const InvitationPage: React.FC = () => {
	const history = useHistory();
	const location = useLocation();
	const match = useRouteMatch();

	const nextStep = (values: any) => {
		const step = +(location.pathname.match(/\d$/) || [0])[0];
		history.push(`/invitation/${step + 1}`);
	};

	return (
		<div className='invitation-page'>
			<Logo />
			<SimpleFormWrapper>
				<Image src={companyLogo} className='company-logo' />
				<Switch>
					<Route path={match.url + '/1'}>
						<UserDetailsForm
							onSubmit={nextStep}
							renderActionButtons={(disableSubmit) => nextButton(disableSubmit)}
						/>
					</Route>
					<Route path={match.url + '/2'}>
						<ChoosePasswordForm
							onSubmit={nextStep}
							renderActionButtons={(disableSubmit) => nextButton(disableSubmit)}
						/>
					</Route>
					<Route path={match.url + '/3'}>
						<div>
							<div className='body'>
								<Header>Invitation Accepted</Header>
								<p>
									You have accepted the invitation to join
									<span className='company-name'> Company Name </span> on My
									Spending Planner.
								</p>
								<p>
									We're excited to have you on board. You can use the URL below
									to visit Company Name on My Spending Planner at any time.
								</p>
							</div>
							<div className='footer'>
								<p>Continue to</p>
								<Button
									fluid
									primary
									content='companyname.myspendingplanner.com.au'
								/>
							</div>
						</div>
					</Route>
					<Redirect to={match.url + '/1'} />
				</Switch>
			</SimpleFormWrapper>
		</div>
	);
};

export default InvitationPage;
